import React from 'react';
import { useTranslation } from 'react-i18next';

import { SearchFacets } from '@uncinc/react-searchkit';
import type { SearchFacetsProps } from '@uncinc/react-searchkit/dist/components/Facets';

import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_WIDE } from '../../../config/constants';
import Dialog from '../../Dialog';
import ActiveFacets from '../ActiveFacets';
import AdvancedFacets from '../AdvancedFacets';

import '../../SearchGeneral/Styles/_facets.scss';

interface SearchFacetItemsProps extends SearchFacetsProps {
  width: number;
}

const SearchOcularDBFacetItems: React.FC<SearchFacetItemsProps> = React.memo((props) => {
  const { width, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <SearchFacets {...restProps} className="SearchOcularDB__Facets">
      <div className={`${width >= SCREEN_WIDE ? 'hidden' : ''}`}>
        <Dialog
          title={t('components.search_general.facets.title')}
          openButtonTitle={t('components.search_general.buttons.refine')}
          ctaButtonTitle={t('components.search_general.buttons.apply_facets')}
        >
          <ActiveFacets className="mb-12" />
          <AdvancedFacets />
        </Dialog>
      </div>

      <div className={`${width < SCREEN_WIDE ? 'hidden' : ''}`}>
        <ActiveFacets className="mb-14" />
        <AdvancedFacets />
      </div>

    </SearchFacets>
  );
});

const SearchOcularDBFacets: React.FC<SearchFacetsProps> = (props) => {
  const { className, ...restProps } = props;
  const { width } = useWindowDimensions();

  return <SearchOcularDBFacetItems {...restProps} width={width} />;
};

export default SearchOcularDBFacets;
